import { queryOptions } from "@tanstack/react-query";

import { getCompany, getCompanyPlans } from "@/generated/api/users";

const companyPlansQuery = (companyId: number) =>
  queryOptions({
    queryFn: ({ signal }) => getCompanyPlans(companyId, undefined, { signal }),
    queryKey: ["company", "plans", companyId],
  });

const companyQuery = (companyId: number) =>
  queryOptions({
    queryFn: ({ signal }) => getCompany(companyId, { signal }),
    queryKey: ["company", companyId],
  });

export { companyPlansQuery, companyQuery };
